import { useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import DonateDialog from "./DonateDialog";

const Footer = () => {
  const [donateOpen, setDonateOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      setEmail("");
      alert("Please enter a valid email address.");
      return;
    }
    if (email) {
      setSubscribed(true);
      setEmail("");
      //TODO: Integrate with email service provider to save the email for newsletter subscription
    }
  };

  return (
    <footer className="border-t border-border py-16 px-6">
      <div className="max-w-narrative mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="font-heading text-lg font-bold text-foreground mb-3">
              VR<span className="text-primary">Rentals</span>
            </h3>
            <p className="font-body text-sm text-muted-foreground leading-relaxed">
              #1 VR rental service in Pune & Mumbai. Rent Meta Quest 3 & Oculus VR headsets near you. Free delivery, preloaded games — rent, play, return.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground mb-3">
              Contact
            </h4>
            <ul className="font-body text-sm text-muted-foreground space-y-2">
              <li>
                <a href="mailto:support@vrrentals.in" className="hover:text-secondary transition-colors">
                  support@vrrentals.in
                </a>
              </li>
              <li>
                <a href="tel:+918308832896" className="hover:text-secondary transition-colors">
                  +91 83088 32896
                </a>
              </li>
              <li>PS-201, Lane 14,Tingre Nagar, Pune, Maharashtra, India</li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground mb-3">
              Stay updated
            </h4>
            {subscribed ? (
              <p className="font-body text-sm text-secondary">Thanks for subscribing!</p>
            ) : (
              <form onSubmit={handleSubscribe} className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  className="flex-1 px-4 py-2.5 rounded-lg bg-muted border border-border text-foreground text-sm font-body placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary"
                />
                <button
                  type="submit"
                  className="px-4 py-2.5 rounded-lg bg-primary text-primary-foreground text-sm font-heading font-semibold hover:opacity-90 transition-opacity"
                >
                  Subscribe
                </button>
              </form>
            )}
          </div>
        </div>

        <div className="flex justify-center mb-8">
          <button
            onClick={() => setDonateOpen(true)}
            className="font-heading text-sm font-semibold px-6 py-2.5 rounded-full border border-secondary/40 text-secondary hover:bg-secondary/10 transition-colors flex items-center gap-2"
          >
            <Heart className="w-4 h-4" />
            Support Us
          </button>
        </div>

        <DonateDialog open={donateOpen} onOpenChange={setDonateOpen} />

        <div className="border-t border-border pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-muted-foreground">
            © 2026 SP Online Company. All rights reserved.
          </p>
          <div className="flex gap-6 font-body text-xs text-muted-foreground">
            <Link to="/privacy-policy" className="hover:text-secondary transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="hover:text-secondary transition-colors">
              Terms of Service
            </Link>
            <Link to="/refund-policy" className="hover:text-secondary transition-colors">
              Refund Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
